var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.9871C13.9424 13.2564 13.8435 13.5062 13.6325 13.6933C13.1367 14.1302 12.4992 14.0987 12.0151 13.6095C11.0117 12.595 10.0111 11.5791 9.0106 10.5632C8.97224 10.5243 8.94272 10.4764 8.90878 10.433C7.45816 11.4071 5.90867 11.7093 4.24851 11.2844C2.88053 10.9328 1.78999 10.1443 0.993107 8.96376C-0.513587 6.73591 -0.318794 3.7031 1.66308 1.6892C3.62871 -0.306736 6.61554 -0.529671 8.83942 0.997955C11.1725 2.5989 12.1671 5.95638 10.4568 8.78421C10.4907 8.82012 10.5261 8.86052 10.5645 8.89792C11.5341 9.88093 12.5006 10.8669 13.4746 11.844C13.7225 12.0923 13.935 12.3527 14 12.7118V12.9886V12.9871ZM9.4843 5.73195C9.47397 3.59088 7.74445 1.84481 5.65338 1.86276C3.53132 1.88221 1.8254 3.61931 1.83868 5.74691C1.85197 7.88948 3.57411 9.62358 5.67551 9.60862C7.78429 9.59366 9.49463 7.85208 9.4843 5.73195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.beae54c70244116e6f551fd0e4398049.svg";
export { ForwardRef as ReactComponent };